import React from "react";
import "../style/Footer.css";
import { FaFacebook, FaInstagram, FaYoutube, FaTiktok } from "react-icons/fa";
import logo from "../assets/bbarive.png";

const Footer = () => {
  return (
    <div className="footer">
      <div className="footer-grid">
        {/* Logo and Social Section */}
        <div className="footer-content">
          <img src={logo} alt="BBArive Logo" className="footer-logo" />
          <div className="store-buttons-footer">
            <a
              href="https://apps.apple.com/your-app-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://developer.apple.com/app-store/marketing/guidelines/images/badge-download-on-the-app-store.svg"
                alt="App Store"
                className="store-button"
              />
            </a>
            <a
              href="https://play.google.com/store/apps/your-app-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                alt="Play Store"
                className="store-button play-store"
              />
            </a>
          </div>
          <div className="social-icons">
            <FaInstagram className="social-icon" />
            <FaYoutube className="social-icon" />
            <FaTiktok className="social-icon" />
            <FaFacebook className="social-icon" />
          </div>
        </div>

        {/* Links Section */}
        <div className="footer-links">
          <div>
            <h4>Quick Links</h4>
            <ul>
              <li>
                <a href="/">Home</a>
              </li>
              <li>
                <a href="/#services">Quick Ride</a>
              </li>
              <li>
                <a href="/#services">Ridesharing</a>
              </li>
            </ul>
          </div>
          <div>
            <h4>Legal</h4>
            <ul>
              <li>
                <a href="/privacy-policy">Privacy Policy</a>
              </li>
              <li>
                <a href="/terms-and-conditions">Terms & Conditions</a>
              </li>
              <li>
                <a href="/#contact">Contact Us</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} BBArive. All rights reserved.</p>
      </div>
    </div>
  );
};

export default Footer;
